import { config } from '@/config/config';
import { getAuthTokens } from '@/storage/auth-tokens.storage';
import { ApiClient, RequestConfig } from '@/utils/api/api-client';

export const restApiClient = new ApiClient(config.restApi.url);

export async function addTokenToRequest(requestConfig: RequestConfig): Promise<RequestConfig> {
  const resolvedHeaders: Record<string, string> = {
    ...(requestConfig.headers || {}),
  };

  const authorization = getAuthTokens();

  if (authorization) {
    const existingAuthorization = requestConfig.headers?.Authorization;
    if (!existingAuthorization) {
      resolvedHeaders['Authorization'] = `Bearer ${authorization.access_token}`;
    }
  }

  return {
    ...requestConfig,
    headers: resolvedHeaders,
  };
}

restApiClient.addRequestInterceptor(addTokenToRequest);
